<template>
  <div class="mt-2 mt-md-5 mb-5">
    <MainWorksSectionHeader :year="year"/>
    <div class="projects-container d-flex flex-wrap justify-content-left">
      <slot></slot>
    </div>
  </div>
</template>

<script>
import MainWorksSectionHeader from "@/components/MainWorksSectionHeader";
// eslint-disable-next-line
import MainWorksProject from "@/components/MainWorksProject";

export default {
name: "MainWorksSection",
  // eslint-disable-next-line
  components: {MainWorksSectionHeader, MainWorksProject},
  props:{
    year:{
      type: String,
      default: "YEAR"
    }
  }
}
</script>

<style scoped>

</style>